module.exports = "//public.getcloudapp.com/packs/media/images/team-a111762a095a6510073b42694ed68eef.svg";